import React from 'react';
import { OrderStatusContext, OrderStatusContextProps } from '../context/OrderStatusContext';
import { OrderStatus } from '../types/order/orderStatus';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const orderStatusState = {
  items: new Map<string, OrderStatus>(),
  loading: false,
};

interface OrderStatusState {
  key: string;
}

export const orderStatusSlice = createSlice({
  name: 'orderStatus',
  initialState: { key: v4() } as OrderStatusState,
  reducers: {
    reset: state => {
      orderStatusState.items = new Map();
      orderStatusState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<OrderStatus[]>) => {
      orderStatusState.items = new Map();
      action.payload.forEach(os => orderStatusState.items.set(os.id, new OrderStatus(os)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<OrderStatus[]>) => {
      action.payload.forEach(os => orderStatusState.items.set(os.id, new OrderStatus(os)));
      orderStatusState.items = new Map(orderStatusState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<OrderStatus[]>) => {
      action.payload.forEach(os => orderStatusState.items.delete(os.id));
      orderStatusState.items = new Map(orderStatusState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      orderStatusState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface OrderStatusProviderProps {
  children: React.ReactNode;
}

export default function OrderStatusProvider({ children }: OrderStatusProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.orderStatuses.key);

  const orderStatusContext: OrderStatusContextProps = {
    orderStatuses: orderStatusState.items,
    orderStatusesLoading: orderStatusState.loading,
    setOrderStatuses: (orderStatuses: Map<string, OrderStatus>) => {
      dispatch(orderStatusSlice.actions.set([...orderStatuses.values()]));
    },
  };

  return <OrderStatusContext.Provider value={orderStatusContext}>{children}</OrderStatusContext.Provider>;
}
